import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
import { invalidateOfficeHoursListCache } from './postOfficeHoursList';

export const deleteOfficeHours = async (
  id: string,
): Promise<{ status: string }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) throw new Error('Customer Id is not available');

  const url = `/resourceMatrix/office_hour/delete?customerId=${customer}`;
  try {
    const response = await post(url, { id });
    invalidateOfficeHoursListCache();
    return response as { status: string };
  } catch (error) {
    throw new Error('Failed to delete office hours');
  }
};

// New bulk delete function for the updated API
export const deleteOfficeHoursBulk = async (
  ids: string[],
): Promise<{ status: string }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) throw new Error('Customer Id is not available');

  const url = `/resourceMatrix/office_hour/delete?customerId=${customer}`;
  try {
    const response = await post(url, { ids });
    invalidateOfficeHoursListCache();
    return response as { status: string };
  } catch (error) {
    throw new Error('Failed to delete office hours');
  }
};
